import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const slice = createSlice({
    name: 'documents',
    initialState,
    reducers: {},
    // extraReducers: builder => {

    // },
});

// export const {  } = slice.actions;

export default slice.reducer;

// export const selectCurrentWorkstation = (state: RootState) => state.workstations.currentWorkstation;
